export function convertToCSV(objArray) {
  const array = typeof objArray === "string" ? JSON.parse(objArray) : objArray;
  if (!Array.isArray(array) || array.length === 0) return "";

  // build header row
  const headers = Object.keys(array[0]);
  const escape = (val) => {
    let s = val == null ? "" : String(val);
    if (s.includes('"')) s = s.replace(/"/g, '""');
    return `"${s}"`;
  };

  let csv = headers.map(escape).join(",") + "\r\n";

  // build data rows
  array.forEach((row) => {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  });

  return csv;
}

/**
 * Aggregate objects by month/year and export a “Gross Sales vs Discount” CSV.
 *
 * @param {Object[]} objects
 * @param {string}   selectedYear        // e.g. “2025”
 * @param {string}   selectedStoreCode   // e.g. “STORE123”
 * @param {string}   fileNamePrefix      // optional prefix for download name
 */
export function exportGrossVsDiscountCSV({
  objects,
  selectedYear,
  selectedStoreCode,
  fileNamePrefix = "DiscountGross",
}) {
  // 1) aggregate data
  const aggregated = {};
  objects
    .filter((o) => o.status === "C")
    .forEach((sale) => {
      const d = new Date(sale.tran_date);
      const year = d.getFullYear();
      const month = d.toLocaleString("default", { month: "long" });
      const store = sale.store_code.replace("ANGELSPIZZA_", "");

      if (selectedYear && year !== parseInt(selectedYear, 10)) return;
      if (selectedStoreCode && store !== selectedStoreCode) return;

      const key = `${month} ${year}`;
      const total = Number(sale.total || 0);
      const discount = Number(sale.discount_amount || 0);

      if (!aggregated[key]) {
        aggregated[key] = {
          Brand: "Angels Pizza",
          Store: store,
          Month: month,
          Year: year,
          "Gross Sales": total,
          "Discount Amount": discount,
        };
      } else {
        aggregated[key]["Gross Sales"] += total;
        aggregated[key]["Discount Amount"] += discount;
      }
    });

  // 2) convert to array and CSV
  const rows = Object.values(aggregated);
  const csvArray = rows.length ? rows : [];
  const csv = convertToCSV(csvArray);

  if (!csv) {
    console.error("exportGrossVsDiscountCSV: nothing to export");
    return;
  }

  // 3) trigger download
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const name = `${fileNamePrefix}_${selectedYear || ""}.csv`;
  link.href = URL.createObjectURL(blob);
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
